/**
 * Trial End Trigger Component
 *
 * Trigger: "a trial ending"
 * Timing only — no Stripe plan fields (v2 parity).
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';

export const TrialEndTrigger: FC<TriggerComponentProps> = ({
  automation,
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    const planName = automation.paymentPlanName;
    if (planName) {
      return <span>{t('automations.triggers.trialEndingFor', { plan: planName })}</span>;
    }
    return <span>{t('automations.triggers.trialEnding')}</span>;
  }

  return null;
};
